
import Vue from "vue";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import AppFilePreview  from "@/components/FileImagePreview.vue";
import { UserInfo } from "@/models/dossier/user-info";

export default Vue.extend({
	data(){
		return {
			value: null as File | null
		};
	},
	props: {
		user: {
			type: Object as ()=>UserInfo,
			required: true
		}
	},
	computed: {
		saveDisabled():boolean {
			if (this.value == null){
				return true;
			}
			return false;
		},
		cancelDisabled():boolean{
			return false;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			if (!this.value){
				return;
			}
			this.$emit("input", this.value);
			this.close();
			return;
		}
	},
	components: {
		AppFileUpload,
		AppFilePreview
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
